/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Fade } from 'react-awesome-reveal';
import { Transition } from '@headlessui/react';
import { useLocation } from 'react-router-dom';

import Button from '../elements/Button';
import BrandIcon from './BrandIcon';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../contexts/LanguageContext';

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const { t } = useLanguage();

  return (
    <header className="header">
      <div className="flex justify-between items-center px-4 lg:px-0 w-full">
        <BrandIcon />

        {/* Mobile Menu Button */}
        <div className="flex items-center space-x-4 lg:hidden">
          <button className="block text-green-600 focus:outline-none" onClick={() => setIsCollapse(!isCollapse)}>
            <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path className={`${isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
              <path className={`${!isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <ul className="hidden text-white tracking-widest items-center lg:flex flex-row mt-0">
        <li className="flex items-center">
          <Button
            className={`${path === '/' ? 'active-link' : ''} font-medium text-base lg:text-lg px-3 xl:px-5 no-underline hover:underline whitespace-nowrap`}
            type="link"
            href="/"
          >
            {t('home')}
          </Button>
        </li>
        <li className="flex items-center">
          <Button
            className={`${path === '/team' ? 'active-link' : ''} font-medium text-base lg:text-lg px-3 xl:px-5 no-underline hover:underline whitespace-nowrap`}
            type="link"
            href="/team"
          >
            {t('about')}
          </Button>
        </li>
        <li className="flex items-center">
          <Button
            className={`${path === '/project' ? 'active-link' : ''} font-medium text-base lg:text-lg px-3 xl:px-5 no-underline hover:underline whitespace-nowrap`}
            type="link"
            href="/project"
          >
            {t('products')}
          </Button>
        </li>
        <li className="flex items-center">
          <Button
            className={`${path === '/blog' ? 'active-link' : ''} font-medium text-base lg:text-lg px-3 xl:px-5 no-underline hover:underline whitespace-nowrap`}
            type="link"
            href="/blog"
          >
            {t('blog')}
          </Button>
        </li>
        <li className="flex items-center">
          <Button
            className="font-medium text-base lg:text-lg ml-2 lg:ml-3 px-4 lg:px-6 py-2 bg-green-700 text-white rounded-full border-2 border-green-600 hover:bg-green-900 transition duration-200 whitespace-nowrap"
            type="link"
            href="/discuss-project"
          >
            {t('contact')}
          </Button>
        </li>
        <li className="flex items-center ml-2 lg:ml-4">
          <LanguageToggle />
        </li>
      </ul>

      <Transition
        show={isCollapse}
        enter="transition-opacity duration-400"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-400"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="transition duration-300 ease-in data-[closed]:opacity-0">

          {/* <Fade> */}
          <ul className="z-50 flex flex-col text-green-600 tracking-widest my-6 absolute bg-white w-full border-b-2 border-gray-300 lg:hidden">
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/' ? 'active-link' : ''} font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/"
              >
                {t('home')}
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/team' ? 'active-link' : ''} font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/team"
              >
                {t('about')}
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/project' ? 'active-link' : ''} font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/project"
              >
                {t('products')}
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/blog' ? 'active-link' : ''} font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/blog"
              >
                {t('blog')}
              </Button>
            </li>
            <li className="mx-auto my-9 bg-white">
              <Button
                className="font-bold mx-auto px-5 py-2 bg-green-800 text-white rounded-full border-2 border-green-600 hover:bg-green-700 transition duration-200"
                type="link"
                href="/discuss-project"
              >
                {t('contact')}
              </Button>
            </li>
            <li className="flex justify-center py-4 bg-white">
              <LanguageToggle />
            </li>
          </ul>
          {/* </Fade> */}
        </div>
      </Transition>
    </header>
  );
}
